import { Fragment, useContext, useEffect, useState } from "react";
import { isValidArray, showCardDetails, showMyWalletClick } from "../../Layout/Common/common";
import Skeleton from "react-loading-skeleton";
import $ from "jquery";
import {
  BANKTRANSFER_TERM,
  MASTERCARD_TERM,
  ONACCOUNT_TERM,
  PAYMENT_RESTRICT_ROLE,
  SHIPPING_METHOD,
  TILL_GPAY_PAYONLINE_ENABLED,
} from "../../constants";
import { NewCardPayment } from "../CheckOutNew/Payment/paymentMethod/newcardPayment";
import { MyWalletPayment } from "../CheckOutNew/Payment/paymentMethod/myWalletPayment";
import { GlobalContext } from "../../Context/GlobalContext";
import { useAuth } from "../../Context/AuthContext";
import { BankTransferPayOnline } from "./bankTransferPayOnline";
import { TillGooglePayOption } from "./tillGooglePayOption";

export const PaymentSectionPayOnline = ({
  TotalAmount,
  is_payAccount = false,
  orderId,
  walletCount,
  onGooglePayBeforePay,
  onGooglePayToken,
}) => {
  const isPayAccount = !!(TotalAmount && TotalAmount.payAccount);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const {
    selectedPaymentType,
    setSelectedPaymentType,
    isSubmitOrder,
    setIsSubmitOrder,
    deliveryMethod,
    paymentOption,
    shippingCode,
    storedCard,
    netAmount,
  } = useContext(GlobalContext);
  const { isAuthenticated } = useAuth();
  useEffect(() => {
    let _paymentOption = [];
    let payTerm = paymentOption;
    const allowGooglePay = TILL_GPAY_PAYONLINE_ENABLED;
    const applyGooglePayRule = (options) => options.filter((item) => item != "TILLGOOGLEPAY" || allowGooglePay);
    if (PAYMENT_RESTRICT_ROLE && payTerm) {
      if (PAYMENT_RESTRICT_ROLE.includes(payTerm.user_role) == false) {
        if (ONACCOUNT_TERM.includes(payTerm.payment_term)) {
          _paymentOption = ["NEWCARD", "TILLGOOGLEPAY", "MYWALLET", "BT"];
        }
        if (MASTERCARD_TERM.includes(payTerm.payment_term)) {
          _paymentOption = ["NEWCARD", "TILLGOOGLEPAY", "MYWALLET", "BT"];
        }
        if (BANKTRANSFER_TERM.includes(payTerm.payment_term)) {
          if (deliveryMethod == SHIPPING_METHOD[2]) _paymentOption = ["NEWCARD", "TILLGOOGLEPAY", "MYWALLET"];
          else _paymentOption = ["NEWCARD", "TILLGOOGLEPAY", "MYWALLET", "BT"];
        }
      }
      if (isValidArray(_paymentOption)) {
        _paymentOption = applyGooglePayRule(_paymentOption);

        if (isValidArray(storedCard) == false) {
          _paymentOption = _paymentOption.filter((item) => item != "MYWALLET");
        }
        setPaymentMethod(_paymentOption);
        setIsSubmitOrder(false);
        setTimeout(() => {
          if (selectedPaymentType) return;
          if (_paymentOption.includes("MYWALLET")) {
            handlePaymentSelection("MYWALLET");
          } else if (_paymentOption.includes("NEWCARD")) {
            handlePaymentSelection("NEWCARD");
          } else {
            handlePaymentSelection(_paymentOption[0]);
          }
        }, 1000);
      } else {
        let payment_Option = applyGooglePayRule(["NEWCARD", "TILLGOOGLEPAY", "MYWALLET", "BT"]);
        setPaymentMethod(payment_Option);
      }
    } else {
      let payment_Option = applyGooglePayRule(["NEWCARD", "TILLGOOGLEPAY", "MYWALLET", "BT"]);
      setPaymentMethod(payment_Option);
    }
  }, [paymentOption, storedCard, isAuthenticated]);

  const paymentComponents = {
    MYWALLET: (props) => <MyWalletPayment {...props} />,
    NEWCARD: (props) => <NewCardPayment {...props} />,
    ...(!is_payAccount ? { BT: (props) => <BankTransferPayOnline {...props} /> } : {}),

    TILLGOOGLEPAY: (props) => (
      <TillGooglePayOption
        handleOnCheck={props.handleOnCheck}
        defaultCheck={props.defaultCheck}
        TotalAmount={props.TotalAmount}
        onBeforePay={props.onBeforePay}
        onToken={props.onToken}
        enabled={TILL_GPAY_PAYONLINE_ENABLED}
      />
    ),
  };

  const handlePaymentSelection = (e) => {
    // if (e == "OA") {
    //   $(".card-details-list1").hide("slow");
    //   $(".acc-details-list1").show("slow");
    //   $(".banktransfer").hide("slow");
    // } else
    if (e == "NEWCARD") {
      $(".card-details-list1").show("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    } else if (e == "BT") {
      $(".banktransfer").show("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
      $(".card-details-list1").hide("slow");
    } else if (e == "TILLGOOGLEPAY") {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").show("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    } else if (e == "MYWALLET") {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    } else {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
      $(".banktransfer").hide("slow");
    }
    setSelectedPaymentType(e);
  };

  return (
    <Fragment>
      {paymentMethod && (
        <div className="selected-shipping-method  col-lg-12">
          <div className="myAcc-list">
            <h3>Payment</h3>
          </div>
          <div className="shipping-method-list">
            <div className="shipPayment-listing" id="accordionExample">
              {paymentMethod.map((type, index) =>
                paymentComponents[type]
                  ? paymentComponents[type]({
                      handleOnCheck: handlePaymentSelection,
                      defaultCheck: selectedPaymentType == type,
                      TotalAmount: TotalAmount,
                      orderId: orderId,
                      wallet: walletCount,
                      onBeforePay: onGooglePayBeforePay,
                      onToken: onGooglePayToken,
                    })
                  : null,
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
